import React, {useEffect, useMemo, useState} from "react";
import {IssueRenderProps} from "@components/grid/IssueGrid";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import {useWishlistAddIssueMutation, useWishlistRemoveIssueMutation} from "@mwServices/User";
import {showResponse} from "@services/Api";
import {IssueActions} from "@lib/constants";
import useIsLoggedIn from "@hooks/useIsLoggedIn";
import ComicPricesModal from "@components/comic-prices-modal";
import IssuesListItemMobile from "@mwPages/issues/IssuesListItemMobile";
import IssuesListItemMobileNoImage from "@mwPages/issues/IssuesListItemMobileNoImage";
import IssuesListItemDesktop from "@mwPages/issues/IssuesListItemDesktop";
import IssuesListItemDesktopNoImage from "@mwPages/issues/IssuesListItemDesktopNoImage";

interface IssuesListItemProps extends IssueRenderProps {
    showEditMultiple?: boolean;
    isSelected?: boolean;
    toggleSelected: (collectionId: number) => void;
    showDesktopView?: boolean;
    showValueRibbon?: boolean;
    allowUnlimited?:boolean;
    windowDimensions?: any;
    showListViewNoImages?: boolean;
    setAddIssueId: (issueId: number) => void;
    listViewColumns?: ListViewColumns;
    showIssueNotes?: boolean;
    shopLink?: {
        slug: string;
        link_url: string;
        image: string;
        active: boolean;
        subtitle?: string;
    } | null;
}

export interface ListViewColumns {
    editMultiple: number;
    bookImage: number;
    issueDetails: number;
    year: number;
    grade: number;
    rawFmv: number;
    slabFmv: number;
    ebay: number;
    priceTable: number;
    actions: number;
    issueLink: number;
};

const IssuesListItem = ({
    item,
    onClick,
    showEditMultiple,
    isSelected,
    toggleSelected,
    showDesktopView,
    showValueRibbon,
    allowUnlimited,
    windowDimensions,
    showListViewNoImages,
    setAddIssueId,
    listViewColumns,
    showIssueNotes,
    shopLink,
}: IssuesListItemProps) => {
    const issueDate = moment(item.date).toDate();
    const navigate = useNavigate();

    const ItemComponent = useMemo(() => {
        if(showDesktopView && !showListViewNoImages) return IssuesListItemDesktop;
        if(showDesktopView && showListViewNoImages) return IssuesListItemDesktopNoImage;
        if(showListViewNoImages) return IssuesListItemMobileNoImage;
        return IssuesListItemMobile;
    }, [showDesktopView])

    const isLoggedIn = useIsLoggedIn();
    const [wishlistIssueAdd, addWishlistResponse] = useWishlistAddIssueMutation();
    const [wishlistIssueRemove, removeWishlistResponse] = useWishlistRemoveIssueMutation();
    const [priceListId, setPriceListId] = useState(null);

    useEffect(() => {
        showResponse(addWishlistResponse, IssueActions.WISHLIST.RESPONSE.ADD, IssueActions.WISHLIST.ERROR.ADD);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addWishlistResponse]);

    useEffect(() => {
        showResponse(removeWishlistResponse, IssueActions.WISHLIST.RESPONSE.REMOVE, IssueActions.WISHLIST.ERROR.REMOVE);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [removeWishlistResponse]);

    return (
        <>
            <ItemComponent
                item={item}
                showEditMultiple={showEditMultiple}
                isSelected={isSelected}
                toggleSelected={toggleSelected}
                onClick={onClick}
                issueDate={issueDate}
                allowUnlimited={allowUnlimited}
                navigate={navigate}
                showValueRibbon={showValueRibbon}
                windowDimensions={windowDimensions}
                wishlistIssueAdd={wishlistIssueAdd}
                wishlistIssueRemove={wishlistIssueRemove}
                isLoggedIn={isLoggedIn}
                setAddIssueId={setAddIssueId}
                showListViewNoImages={showListViewNoImages}
                setPriceListId={setPriceListId}
                listViewColumns={listViewColumns}
                showIssueNotes={showIssueNotes}
                shopLink={shopLink}
            />
            {priceListId && (
                <ComicPricesModal isModalOpen={true} issueId={priceListId} onCancel={() => setPriceListId(null)} info={{key_info: item.key_info, slug: item.slug}} />
            )}
        </>
    );
};

export default IssuesListItem;